import React, { useState } from 'react';
import { Grid, Typography, Box, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import a1 from '../../Assets/comprehensing-monitoring.webp';
import a2 from '../../Assets/user-friendly-dashboard.webp';
import a3 from '../../Assets/customize-sol.jpg';
import a4 from '../../Assets/security-first.jpg';

function AboutUs() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navigate = useNavigate();

  const cards = [
    {
      image: a1,
      title: 'Complete Server Monitoring',
      description:
        'Get real-time insights into your server’s performance, uptime, speed, and health. WatchNod alerts you instantly when something needs attention so you can fix issues before they affect your business. Stay in control with proactive monitoring that keeps everything running smoothly.',
    },
    {
      image: a2,
      title: 'Scalable & Flexible Solutions',
      description:
        'No matter your business size startup, growing team, or large enterprise WatchNod adapts to your needs. Our customizable monitoring tools and scalable features grow with you, ensuring the perfect fit for your infrastructure.',
    },
    {
      image: a3,
      title: 'Easy-to-Use Dashboard',
      description:
        "Manage everything from one clean, user-friendly dashboard. Track server performance, view key metrics, and create detailed reports in just a few clicks. We’ve designed it to save your time and make server management simple even if you're not a tech expert.",
    },
    {
      image: a4,
      title: 'Enterprise-Grade Security',
      description:
        'Your data is safe with us. WatchNod uses advanced encryption and 24/7 monitoring to keep your servers secure. Focus on your business while we protect your infrastructure with top-tier security practices.',
    },
  ];

  return (
    <Container maxWidth="xl" sx={{ py: 6 }}>
      <Typography
        component="h1"
        variant="h3"
        textAlign='center'
        mb={6}
        sx={{
          fontWeight: 700,
          color: 'text.primary',
        }}
      >
        About WatchNod: Your Partner in Seamless Node and API Monitoring
      </Typography>

      <Typography
        variant="body1"
        sx={{
          textAlign: 'justify',
          mx: 'auto',
          color: 'text.secondary',
          mb: 2,
          maxWidth: '1400px',
        }}
      >
        At Watch-Nod, we empower businesses to monitor their servers and websites with smart,
        reliable, and easy-to-use tools. Whether you're a small business or a growing enterprise,
        our solutions are designed to keep your infrastructure running smoothly—24/7.
      </Typography>
      <Typography
        variant="body1"
        sx={{
          textAlign: 'justify',
          mx: 'auto',
          color: 'text.secondary',
          mb: 2,
          maxWidth: '1400px',
        }}
      >
        Powered by the trusted legacy of<b> ResourceDekho</b>, we blend deep technical expertise with a passion for innovation to redefine server and API monitoring. Our focus is on simplicity, performance, and trust—so you can manage, scale, and maintain your systems with complete confidence and zero hassle.

      </Typography>
      <Typography
        variant="body1"
        sx={{
          textAlign: 'justify',
          mx: 'auto',
          color: 'text.secondary',
          mb: 2,
          maxWidth: '1400px',
        }}
      >
        Our core services include advanced<b> Node Monitoring </b>and <b>API Monitoring</b>, built to keep your systems online, optimized, and secure. With real-time alerts and actionable insights, we help eliminate downtime and ensure peak performance across your infrastructure.

      </Typography>
      <Typography
        variant="body1"
        sx={{
          textAlign: 'justify',
          mx: 'auto',
          color: 'text.secondary',
          mb: 10,
          maxWidth: '1400px',
        }}
      >
        Behind every solution at Watch-Nod is a team driven by purpose. Our engineers and support experts share a commitment to building smarter, simpler tools that empower your business. With innovation at our core and a customer-first approach, we're shaping the future of digital monitoring—one solution at a time.
      </Typography>

      {/* Feature Cards */}
      <Grid container spacing={6} justifyContent="center">
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Box
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{
                ...styles.card,
                ...(hoveredIndex === index ? styles.cardHover : {}),
              }}
            >
              {card.image && (
                <Box
                  component="img"
                  src={card.image}
                  alt={card.title}
                  loading="lazy"
                  sx={{
                    width: '100%',
                    height: 150,
                    borderRadius: 2,
                    objectFit: 'cover',
                    marginBottom: 2,
                    backgroundColor: '#ddd',
                  }}
                />
              )}
              <Typography variant="h6" style={styles.cardTitle}>
                {card.title}
              </Typography>
              <Typography variant="body2" style={styles.cardText}>
                {card.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* New Sections */}
      <Grid container spacing={4} sx={{ mt: 8 }}>
        {/* Subscription Section */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              p: 4,
              borderRadius: 3,
              boxShadow: 2,
              backgroundColor: '#f0f8ff',
              height: '100%',
            }}
          >
            <Typography variant="h5" sx={{ color: '#004080', mb: 2, fontWeight: 600 }}>
              Flexible Subscription Plans
            </Typography>
            <Typography variant="body1" sx={{ color: '#003366', mb: 3 }}>
              Choose a pricing plan that suits your needs. Whether you’re an individual, a
              startup, or an enterprise—WatchNod offers transparent and affordable pricing
              for all.
            </Typography>
            <Button
              component="a"
              href="/#pricing"
              variant="contained"
              color="primary"
              onClick={(e) => {
                e.preventDefault();
                navigate('/#pricing');
              }}
              sx={{ textDecoration: 'none' }}
            >
              View Pricing
            </Button>
          </Box>
        </Grid>

        {/* Contact Section */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              p: 4,
              borderRadius: 3,
              boxShadow: 2,
              backgroundColor: '#f0f8ff',
              height: '100%',
            }}
          >
            <Typography variant="h5" sx={{ color: '#004080', mb: 2, fontWeight: 600 }}>
              Have Questions? Contact Us!
            </Typography>
            <Typography variant="body1" sx={{ color: '#004080', mb: 3 }}>
              Our team is here to help. Reach out to us for queries, technical support, or
              just to say hello. We're happy to assist you!
            </Typography>
            <Button
              component="a"
              href="/contact"
              variant="contained"
              color="primary"
              onClick={(e) => {
                e.preventDefault();
                navigate('/contact');
              }}
              sx={{ textDecoration: 'none' }}
            >
              Contact Us
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Container >
  );
}

const styles = {
  card: {
    backgroundColor: 'white',
    border: '1px solid #0056b3',
    borderRadius: '15px',
    padding: '30px',
    boxShadow: '0 8px 20px rgba(0, 64, 128, 0.15)',
    textAlign: 'center',
    height: '100%',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
  cardHover: {
    transform: 'translateY(-8px)',
    boxShadow: '0 12px 28px rgba(0, 64, 128, 0.25)',
  },
  cardTitle: {
    color: '#004080',
    fontSize: '1.2rem',
    fontWeight: '700',
    marginBottom: '10px',
  },
  cardText: {
    color: '#003366',
    fontSize: '1rem',
    lineHeight: '1.6',
    textAlign: 'justify',
  },
  icon: {
    marginBottom: '15px',
  },
};

export default AboutUs;
